module.exports = __webpack_public_path__ + "static/img/img_ai_ar_04.297592b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img_ai_ar_04.jpg
// module id = YfQ3
// module chunks = 1